import { render, staticRenderFns } from "./InventoryReservationIndex.vue?vue&type=template&id=345011d3&scoped=true"
import script from "./InventoryReservationIndex.vue?vue&type=script&lang=js"
export * from "./InventoryReservationIndex.vue?vue&type=script&lang=js"
import style0 from "./InventoryReservationIndex.vue?vue&type=style&index=0&id=345011d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345011d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345011d3')) {
      api.createRecord('345011d3', component.options)
    } else {
      api.reload('345011d3', component.options)
    }
    module.hot.accept("./InventoryReservationIndex.vue?vue&type=template&id=345011d3&scoped=true", function () {
      api.rerender('345011d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryReservationIndex.vue"
export default component.exports